import { render, staticRenderFns } from "./InquiryDetailBenefitAmount.vue?vue&type=template&id=1eb8cf9d&scoped=true"
import script from "./InquiryDetailBenefitAmount.vue?vue&type=script&lang=js"
export * from "./InquiryDetailBenefitAmount.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetailBenefitAmount.vue?vue&type=style&index=0&id=1eb8cf9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8cf9d",
  null
  
)

export default component.exports